import React from 'react';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { Building2, Handshake, Globe, ArrowRight } from 'lucide-react';
import { ContactForm } from '../components/ContactForm';
export const SchoolsPartnerships = () => {
  return <div className="pt-20" data-id="element-512">
      {/* Hero */}
      <div className="bg-teal-50 py-20 md:py-32" data-id="element-513">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-514">
          <div className="max-w-3xl" data-id="element-515">
            <div className="inline-block px-4 py-2 bg-white text-teal-600 rounded-full font-semibold text-sm mb-6 shadow-sm" data-id="element-516">
              Partnerships
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-[#0A2540] mb-6 leading-tight" data-id="element-517">
              Let's Build the Future{' '}
              <span className="text-teal-600" data-id="element-518">Together</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-519">
              We partner with schools, governments, and NGOs to deliver
              scalable, high-impact AI education programs across Africa.
            </p>
          </div>
        </div>
      </div>

      {/* Partnership Models */}
      <Section data-id="element-520">
        <div className="text-center mb-16" data-id="element-521">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-4" data-id="element-522">
            Ways to Partner
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-523">
          <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-524">
            <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6" data-id="element-525">
              <Building2 className="w-7 h-7 text-teal-600" data-id="element-526" />
            </div>
            <h3 className="text-2xl font-bold text-[#0A2540] mb-4" data-id="element-527">
              For Schools
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-528">
              Integrate our curriculum into your school's offering. We provide
              teacher training, materials, and support.
            </p>
            <ul className="space-y-2 mb-8 text-sm text-gray-600" data-id="element-529">
              <li data-id="element-530">• Full curriculum access</li>
              <li data-id="element-531">• Teacher certification</li>
              <li data-id="element-532">• Student hackathons</li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-533">
            <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-534">
              <Handshake className="w-7 h-7 text-blue-600" data-id="element-535" />
            </div>
            <h3 className="text-2xl font-bold text-[#0A2540] mb-4" data-id="element-536">
              Corporate CSR
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-537">
              Sponsor a school or a region. Help bridge the digital divide as
              part of your corporate social responsibility.
            </p>
            <ul className="space-y-2 mb-8 text-sm text-gray-600" data-id="element-538">
              <li data-id="element-539">• Brand visibility</li>
              <li data-id="element-540">• Impact reporting</li>
              <li data-id="element-541">• Employee volunteering</li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-542">
            <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6" data-id="element-543">
              <Globe className="w-7 h-7 text-orange-600" data-id="element-544" />
            </div>
            <h3 className="text-2xl font-bold text-[#0A2540] mb-4" data-id="element-545">
              NGOs & Govts
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-546">
              Collaborate on large-scale implementation projects to upskill
              youth at a national or regional level.
            </p>
            <ul className="space-y-2 mb-8 text-sm text-gray-600" data-id="element-547">
              <li data-id="element-548">• Policy advisory</li>
              <li data-id="element-549">• Large-scale training</li>
              <li data-id="element-550">• Localization</li>
            </ul>
          </div>
        </div>
      </Section>

      {/* Delivery Model */}
      <Section background="gray" data-id="element-551">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-552">
          <div data-id="element-553">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-6" data-id="element-554">
              How We Deliver Impact
            </h2>
            <div className="space-y-8" data-id="element-555">
              <div className="flex gap-6" data-id="element-556">
                <div className="text-4xl font-bold text-gray-200" data-id="element-557">01</div>
                <div data-id="element-558">
                  <h4 className="text-xl font-bold text-[#0A2540] mb-2" data-id="element-559">
                    Needs Assessment
                  </h4>
                  <p className="text-gray-600" data-id="element-560">
                    We evaluate the infrastructure and digital literacy levels
                    of the partner school or community.
                  </p>
                </div>
              </div>
              <div className="flex gap-6" data-id="element-561">
                <div className="text-4xl font-bold text-gray-200" data-id="element-562">02</div>
                <div data-id="element-563">
                  <h4 className="text-xl font-bold text-[#0A2540] mb-2" data-id="element-564">
                    Teacher Training
                  </h4>
                  <p className="text-gray-600" data-id="element-565">
                    We train local educators first. Sustainable change happens
                    when local teachers are empowered.
                  </p>
                </div>
              </div>
              <div className="flex gap-6" data-id="element-566">
                <div className="text-4xl font-bold text-gray-200" data-id="element-567">03</div>
                <div data-id="element-568">
                  <h4 className="text-xl font-bold text-[#0A2540] mb-2" data-id="element-569">
                    Curriculum Deployment
                  </h4>
                  <p className="text-gray-600" data-id="element-570">
                    We roll out age-appropriate modules, starting with
                    fundamentals and progressing to projects.
                  </p>
                </div>
              </div>
              <div className="flex gap-6" data-id="element-571">
                <div className="text-4xl font-bold text-gray-200" data-id="element-572">04</div>
                <div data-id="element-573">
                  <h4 className="text-xl font-bold text-[#0A2540] mb-2" data-id="element-574">
                    Ongoing Support
                  </h4>
                  <p className="text-gray-600" data-id="element-575">
                    We provide continuous mentorship, updated materials, and
                    community events.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-576">
            <h3 className="text-2xl font-bold text-[#0A2540] mb-6" data-id="element-577">
              Partner With Us
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-578">
              Interested in bringing AI education to your community? Fill out
              the form below to get the conversation started.
            </p>
            <Link to="/contact" data-id="element-579">
              <Button className="w-full" size="lg" data-id="element-580">
                Contact Partnership Team
              </Button>
            </Link>
          </div>
        </div>
      </Section>
    </div>;
};